/**
 * @file Web Galleries master view.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';
import { graphql, withApollo } from 'react-apollo';

import PhoneAuthModal from '../../../components/auth/PhoneAuthModal';
import BrowserDetect from '../../../components/global/BrowserDetect';
import InternetExplorerWarning from '../../../components/global/InternetExplorerWarning';
import { trackAuthEvent } from '../utilities/analytics';
import WebGalleryAnalyticsInitContainer from '../containers/WebGalleryAnalyticsInitContainer';
import { UsernameSelectModal } from '../components/UsernameSelect';
import { WebGalleryProOnboardingInterstitialModal } from './WebGalleryProOnboardingInterstitial';
import { CheckoutCartModal } from '../../../services/checkout/components/CheckoutCart';
import { MeQuery } from '../../admin/graphql/queries/account';
import withGoogleRecaptchaProvider from '../../../components/auth/hocs/withGoogleRecaptchaProvider';

const propTypes = {
  route: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  client: PropTypes.shape({
    resetStore: PropTypes.func,
  }),
};

const WebGalleriesMasterView = ({ route, client }) => {
  return (
    <Fragment>
      <BrowserDetect browsers={['ie']}>
        <InternetExplorerWarning />
      </BrowserDetect>

      {renderRoutes(route.routes)}
      <CheckoutCartModal
        onSuccess={() => {
          // We gotta nuke everything until we can find a way to clear
          // only the relevant data that need clearing (i.e. AlbumMembershipGroup
          // and purchases, purchased custom prints, etc).
          client.resetStore();
        }}
      />
      <PhoneAuthModal onLogin={trackAuthEvent} enableEmailPinAuth />
      <UsernameSelectModal />
      <WebGalleryAnalyticsInitContainer />
      <WebGalleryProOnboardingInterstitialModal />
    </Fragment>
  );
};

WebGalleriesMasterView.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const withMeQuery = graphql(MeQuery, {
  props: ({ data: { me } }) => ({
    user: me,
  }),
  skip: ownProps => !ownProps.authenticated,
});

export default compose(
  withApollo,
  withGoogleRecaptchaProvider,
  connect(mapStateToProps),
  withMeQuery,
)(WebGalleriesMasterView);
